import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const AlertModal = ({ propShow, setPropShow, message, status }) => {
    const handleClose = () => setPropShow(false);
    const navigate = useNavigate();  // Hook para navegação
 
    useEffect(() => {
        if (propShow) {

            if (status == 200) {
                const time = setInterval(() => {
                    setPropShow(false);
                }, 1500);
                return () => {
                    clearInterval(time);
                    if (status == 200) {
                        navigate('/home');
                    }
                }
            } else {

            }
        }
    }, [propShow, setPropShow, navigate]);

    return (
        <>
            <Modal show={propShow} onHide={handleClose}>
                <Modal.Header className='d-flex justify-content-center align-items-center' >
                    <h5 className='text-secondary'>{message}</h5>
                </Modal.Header>
            </Modal>
        </>
    );
}

export default AlertModal;
